import React, { useEffect } from 'react'
import Footer from '../../componets/General/Footer'
import NavBar from '../../componets/General/NavBar'

const Multiplicador = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    return (
        <>
        <NavBar/>
        
            <iframe style = {{height: "1200px"}} src="https://llfreedll.github.io/multiplicador-constante/" className = "w-100" >
            </iframe>
        
        <Footer/>
        </>
    )
}

export default Multiplicador 